import { WalletType } from "../shared/wallet";
export const walletTypeToRujira = async (walletType) => {
    switch (walletType) {
        case WalletType.compass:
            return "Keplr";
        case WalletType.cosmostation:
            return "Keplr";
        case WalletType.cosmostationMobile:
            return "Keplr";
        case WalletType.keplr:
            return "Keplr";
        case WalletType.keplrMobile:
            return "Keplr";
        case WalletType.leap:
            return "Leap";
        case WalletType.leapMobile:
            return "Leap";
        case WalletType.metamask:
            return "Metamask";
        case WalletType.okx:
            return "Keplr";
        case WalletType.walletConnect:
            return "Keplr";
        case WalletType.viewing:
            return "Keplr";
        case WalletType.vultisig:
            return "Vultisig";
        case WalletType.xdefi:
            return "Keplr";
    }
};
export const walletTypeFromRujira = async (rujiraWalletType) => {
    switch (rujiraWalletType) {
        case "Brave":
            return WalletType.keplr;
        case "Coinbase":
            return WalletType.keplr;
        case "Ctrl":
            return WalletType.keplr;
        case "DaoDao":
            return WalletType.keplr;
        case "Keplr":
            return WalletType.keplr;
        case "Leap":
            return WalletType.leap;
        case "Ledger":
            return WalletType.keplr;
        case "Metamask":
            return WalletType.metamask;
        case "Okx":
            return WalletType.okx;
        case "Rabby":
            return WalletType.keplr;
        case "Station":
            return WalletType.keplr;
        case "Tronlink":
            return WalletType.keplr;
        case "Trust":
            return WalletType.keplr;
        case "Vultisig":
            return WalletType.vultisig;
        case "Xaman":
            return WalletType.keplr;
    }
};
export const getWalletProvider = async (rujiraWalletType) => {
    const { wallets } = await import("rujira.ui");
    return wallets.getWalletProvider(rujiraWalletType);
};
//# sourceMappingURL=wallet.js.map